<template>
  <div id="ourCoreValues" class="w-full relative flex flex-col">
    <div id="ourCoreValuesBanner" class="relative">
      <!-- banner -->
      <VideoBackground :src="commonStore.getVideoUrl('CoreValues', 'mp4')" class="absolute" style="width: 100%; height: 30vw" overlay="linear-gradient(0,#215650E5,#215650E5)">
        <!-- content -->
        <div id="ourCoreValuesBannerContent" class="flex px-16">
          <img src="@/assets/images/home/quoteIconLeft.svg" class="self-start mt-10" style="width: 5.18vw" />
          <div class="flex-1 text-center pt-20">
            <div class="text-bold text-6xl text-banner-content">{{ t("home.ourCoreValues") }}</div>
            <img src="@/assets/images/shared/starIconWhite.svg" class="m-auto mt-2 mb-3.5" style="width: 1.76vw" />
            <div class="text-white text-lg mb-10 font-jost" v-html="t('home.ourCoreValuesDesc')"></div>
          </div>
          <img src="@/assets/images/home/quoteIconRight.svg" class="mt-40" style="width: 5.18vw" />
        </div>
      </VideoBackground>
    </div>

    <div id="ourCoreValuesCategories" class="absolute w-full flex justify-center items-center space-x-16" style="top: 20vw">
      <span v-for="(item, index) in homeStore.ourCoreValuescategoryList" :key="'ourCoreValuesCategoryItem' + index">
        <div class="text-bold text-5xl text-banner-content pl-6 pb-6">
          {{ item.label }}
        </div>
        <img :src="commonStore.getImgUrl('home', 'ethics', 'png')" style="width: 11.1vw" v-show="item.id == 'ethics'" />
        <img :src="commonStore.getImgUrl('home', 'synergy', 'png')" style="width: 11.1vw" v-show="item.id == 'synergy'" />
        <img :src="commonStore.getImgUrl('home', 'teamwork', 'png')" style="width: 11.1vw" v-show="item.id == 'teamwork'" />
      </span>
    </div>

    <div class="flex flex-col justify-end items-center mt-auto" style="padding-top: 9vw">
      <div class="text-center w-1/2 text-base font-jost text-2xl" v-html="t('home.categoryDesc')" />
      <!-- <button-util buttonType="submit" bgColor="#603813" label="common.learnMore" @click="routeTo('comingsoon')" class="mt-12" /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHomeStore } from "@/stores/home";
import { useRouter } from "vue-router";
import { computed, onMounted, ref, toRefs } from "vue";
import VideoBackground from "vue-responsive-video-background-player";
import { useCommonStore } from "@/stores/common";
import { Plugin } from "vue-responsive-video-background-player";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const router = useRouter();
const commonStore = useCommonStore();
const homeStore = useHomeStore();

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>

